import {
  Shift,
  User,
  dayMonthDateString,
  timeStringFrom24HourTimeString,
} from '@nextforce/api'
import { Text, makeStyles } from '@rneui/themed'
import { View } from 'react-native'
import { useThemeChange } from 'settings/change_theme'
import { Rating } from 'shared/components/rating'
import { UserAvatar } from 'shared/components/user/user_avatar'
import { CrewRating } from '../queries/shared/types'

interface CrewRatingCardProps {
  shift: Shift
  rater: User
  onChangeCrewRating: (crewRating: CrewRating) => void
}

export function CrewRatingCard({
  shift,
  rater,
  onChangeCrewRating,
}: CrewRatingCardProps) {
  const { dark } = useThemeChange()
  const styles = useStyles(dark)
  return (
    <View style={styles.card}>
      <View style={{ paddingVertical: 10 }}>
        <UserAvatar user={shift?.user} size="large" showAvatarIfNoPhone />
      </View>
      <View style={{ flex: 1, paddingHorizontal: 10 }}>
        <Text
          style={[styles.name, styles.text]}
        >{`${shift.user?.firstName} ${shift.user?.lastName}`}</Text>
        <Text style={styles.text}>{`${dayMonthDateString(
          shift.date
        )} , ${timeStringFrom24HourTimeString(shift.startTime)}`}</Text>
        <View style={{ flexWrap: 'wrap' }}>
          <Rating
            size={25}
            onFinishRating={rating => {
              onChangeCrewRating({
                shiftId: shift.id,
                rating: rating,
                raterId: rater.id,
              })
            }}
            defaultRating={0}
          />
        </View>
      </View>
    </View>
  )
}

const useStyles = makeStyles((theme, darkMode) => ({
  card: {
    flexDirection: 'row',
    marginHorizontal: 10,
    marginTop: 10,
    marginBottom: 10,
    backgroundColor: theme.colors.white,
    borderRadius: 8,
    padding: 10,
  },
  text: {
    padding: 3,
    color: theme.colors.black,
  },
  name: {
    fontWeight: 'bold',
    fontSize: 16,
  },
}))
